import axios from 'axios';

export default {
    state: {
        login: false,
        usertoken: undefined,
        username: undefined,
        nickname: undefined,

        userType: undefined,
        challengeId: undefined,
        code: undefined,
        reward: undefined,
        penalty: undefined,
        days: undefined,
        finished: undefined,
        succeed: undefined,

        pushToken: undefined,
        notification: 0
    },
    getters: {
        login: state => state.login,
        challengeId: state => state.challengeId,
        userType: state => state.userType,
        nickname: state => state.nickname,
        notification: state => state.notification,
        finished: state => state.finished,
        succeed: state => state.succeed
    },
    mutations: {
        login(state, payload) {
            state.login = true;
            state.usertoken = payload.token;
            state.username = payload.username;
            state.nickname = payload.nickname;
        },
        nickname(state, payload) {
            state.nickname = payload;
        },
        challenge(state, payload) {
            state.challengeId = payload.id;
            state.code = payload.code;
            state.userType = payload.type;

            state.finished = (payload.is_succeed === null) ? false : true;
            state.succeed = payload.is_succeed;

            state.reward = payload.reward;
            state.penalty = payload.penalty;
            state.days = payload.days;
        },
        logout(state) {
            state.login = false;
            state.usertoken = undefined;
            state.username = undefined;
            state.userType = undefined;
            state.nickname = undefined;
            state.challengeId = undefined;
            state.pushToken = undefined;
            state.nickname = undefined;
            state.notification = 0;

            state.finished = undefined;
            state.succeed = undefined;

            state.reward = undefined;
            state.penalty = undefined;
            state.days = undefined;
        },
        notification(state, payload) {
            state.notification = payload;
        }
    },
    actions: {
        async login({ commit }, { body }) {
            window.localStorage.setItem('userInfo', JSON.stringify(body));
            axios.defaults.headers.common['Authorization'] = body.token;
            await commit('login', body);
            return true;
        },
        async challenge({ commit }) {
            var challengeInfo = window.localStorage.getItem('challengeInfo');

            if (challengeInfo) {
                challengeInfo = JSON.parse(challengeInfo);

                await commit('challenge', challengeInfo);
            }
            return true;
        },
        logout({ commit }) {
            var token = window.localStorage.getItem('pushToken');
            window.localStorage.removeItem('userInfo');
            window.localStorage.removeItem('challengeInfo');

            if (token) {
                axios
                    .delete("/users/tokens?token=" + token)
                    .then((response) => {
                        window.localStorage.removeItem('pushToken');
                    });
            }
            return commit('logout');
        },
        async userInfoSync({ commit }) {
            var userInfo = window.localStorage.getItem('userInfo');
            if (userInfo) {
                userInfo = JSON.parse(userInfo);
                axios.defaults.headers.common['Authorization'] = userInfo.token;
                await commit('login', userInfo);
            }
            return true;
        },
        nickname({ commit }, { nickname }) {
            return axios
                .post('/users/nicknames', { nickname: nickname })
                .then((response) => {

                    var userInfo = window.localStorage.getItem('userInfo');
                    userInfo = JSON.parse(userInfo);
                    userInfo.nickname = nickname;
                    window.localStorage.setItem('userInfo', JSON.stringify(userInfo));

                    commit('nickname', nickname);
                })
        },
        async getNotification({ commit }, { body }) {
            if (body.challengeId) {
                return axios
                    .get('/challenges/' + body.challengeId + '/notifications')
                    .then((response) => {
                        commit('notification', response.data);
                    });
            } else {
                return false
            }
        },
        async checkNotification({ commit }, { body }) {
            return axios
                .post('/challenges/' + body.challengeId + '/notifications')
                .then((response) => {
                    commit('notification', response.data);
                });
        },
    }
}